import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import DashboardLayout from "@/components/layouts/DashboardLayout";
import { Helmet } from "react-helmet";
import { Loader2 } from "lucide-react";
import { ProfileForm } from "@/components/profile/ProfileForm";
import { FamilyManagement } from "@/components/family/FamilyManagement";

export default function Profile() {
  const [profile, setProfile] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setIsLoading(true);
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          console.log("No authenticated user found");
          return;
        }

        console.log("Fetching profile for user:", user.id);
        const { data: profileData, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single();

        if (error) {
          console.error('Profile fetch error:', error);
          if (error.code === 'PGRST116') {
            const { data: newProfile, error: createError } = await supabase
              .from('profiles')
              .insert([{
                id: user.id,
                email: user.email,
                role: 'customer',
                client_number: `${new Date().getFullYear()}-${Math.random().toString(36).substring(7)}`
              }])
              .select()
              .single();

            if (createError) {
              throw createError;
            }
            setProfile(newProfile);
          } else {
            throw error;
          }
        } else {
          console.log("Profile data fetched:", profileData);
          setProfile(profileData);
        }
      } catch (error: any) {
        console.error('Error in profile fetch process:', error);
        toast({
          title: "Error",
          description: "Failed to load profile data. Please try refreshing the page.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, [toast]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <Loader2 className="h-8 w-8 animate-spin" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Profile Settings - NumberzInsight</title>
        <meta name="description" content="Update your profile information and manage your account settings" />
      </Helmet>
      <div className="container max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8 space-y-6">
        <Card className="p-6">
          <ProfileForm profile={profile || {}} />
        </Card>
        
        <FamilyManagement />
      </div>
    </DashboardLayout>
  );
}